<div class="relative">
  <button
    type="button"
    class="inline-flex h-9 cursor-pointer items-center gap-2 rounded-md border border-slate300 bg-white px-3 text-xs font-medium text-slate600 transition hover:border-indigo200 hover:text-indigo700"
    (click)="toggle()"
    [attr.aria-expanded]="isOpen"
  >
    <svg width="16" height="16" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M3 4.5h14M3 10h14M3 15.5h14" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" />
    </svg>
    Columns
    <span class="inline-flex h-5 min-w-5 items-center justify-center rounded-full bg-indigo50 px-1.5 text-[11px] font-semibold text-indigo600">
      {{ visibleCount }}
    </span>
  </button>

  @if (isOpen) {
    <div class="absolute right-0 z-30 mt-1 w-56 rounded-lg border border-slate200 bg-white p-2 shadow-lg">
      <div class="flex items-center justify-between px-2 py-1">
        <span class="text-[11px] font-semibold uppercase tracking-wide text-slate500">Show columns</span>
        <button type="button" class="cursor-pointer text-[11px] font-semibold text-indigo600 hover:underline" (click)="selectAll()">
          Select all
        </button>
      </div>

      <div class="mt-1 max-h-64 space-y-0.5 overflow-y-auto">
        @for (column of columns; track column.key) {
          <label class="flex cursor-pointer items-center gap-2 rounded-md px-2 py-1.5 text-xs font-medium text-slate700 hover:bg-slate50">
            <app-reusable-checkbox
              [ngModel]="isVisible(column.key)"
              [disabled]="isLocked(column.key)"
              (ngModelChange)="onToggleColumn(column.key, $event)"
            ></app-reusable-checkbox>
            {{ column.label }}
          </label>
        }
      </div>
    </div>
  }
</div>
